<div class="title-bar header4-text" *ngIf="title">
  {{title}}
</div>
<app-list-all
  [results]="contentList"
  [showNoResults]="count === 0"
  [moduleName]="''"
  (clickRow)="onContentClick($event)"
  (clickImageCounter)="navigateToAnalysisView($event, 'images')"
  (clickFileCounter)="navigateToAnalysisView($event)"
>
</app-list-all>
